export default {
    intervals: {
        LIVE: 'last_100',
        LAST_100: 'last_100',
        LAST_15_MINUTES: 'last_15_minutes',
        LAST_4_HOURS: 'last_4_hours',
        LAST_24_HOURS: 'last_24_hours'
    }
}